module.exports = __webpack_public_path__ + "img/jala.27073b53.svg";